var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('layout-simple', {
    attrs: {
      "isGoHomeOnBack": _vm.isGoHomeOnBack
    }
  }, [_c('partner-form-detail', {
    attrs: {
      "displayToDetailView": false,
      "loading": _vm.loading
    }
  })], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }